
export async function glideProductListInit() {
    const elements = document.querySelectorAll('.glide--product-list');
    if (elements.length) {
        let {default: Glide, Anchors, Breakpoints, Controls} = await import('@glidejs/glide/dist/glide.modular.esm');
        elements.forEach(element => {
            let productListSlider = new Glide(element, {
                // type: 'carousel',
                // gap: '20px',
                perView: 6,
                // peek: 100,
                // bound: true,
                breakpoints: {
                    575: {
                        perView: 1
                    },
                    767: {
                        perView: 2
                    },
                    1199: {
                        perView: 3
                    },
                    1459: {
                        perView: 4
                    }
                }
            })
    
            let addedToCartModal = document.querySelector('#addedToCartModal');
            addedToCartModal?.addEventListener('shown.bs.modal', () => {
                productListSlider.update();
            });
    
            let tabElList = document.querySelectorAll('button[data-bs-toggle="tab"], .nav-product-content .nav-link')
            tabElList?.forEach(tabEl => {
                tabEl.addEventListener('shown.bs.tab', function () {
                    productListSlider.update();
                })
            });

            const updateArrowsVisibility = () => {
                const currentIndex = productListSlider.index;
                const rightArrow = element.querySelector('.glide__arrow--right');
                const leftArrow = element.querySelector('.glide__arrow--left');
                const totalSlides = element.querySelectorAll('.glide__slide').length;

                if (totalSlides <= productListSlider.settings.perView) {
                  leftArrow.classList.add('hidden');
                  rightArrow.classList.add('hidden');
                } else {
                  leftArrow.classList.remove('hidden');
                  rightArrow.classList.remove('hidden');
                  if (currentIndex === 0) {
                    leftArrow.classList.add('hidden');
                  } else if (currentIndex === totalSlides - productListSlider.settings.perView) {
                    rightArrow.classList.add('hidden');
                  }
                }
            };

            productListSlider.on(['mount.after', 'run.after'], updateArrowsVisibility);

            productListSlider.mount({Anchors, Breakpoints, Controls});

            element.addEventListener('mouseover', () => {
                const buttons = element.querySelectorAll('.glide__arrow');
                buttons.forEach(btn => {
                    btn.style.display = 'block';
                });
            });
    
            element.addEventListener('mouseout', () => {
                const buttons = element.querySelectorAll('.glide__arrow');
                buttons.forEach(btn => {
                    btn.style.display = 'none';
                });
            });
        });
    }
}